<template>
  <ul id="slide-out" class="sidenav collapsible">
    <li>
      <div class="user-view">
        <div class="background">
          <img :src="image">
        </div>
        <a href="#!name"><span class="white-text name">{{ user.name }}</span></a>
        <a href="#!email">
              <span class="white-text email">
                {{ user.email }}<br>
                  {{roleNames}}
              </span>
        </a>
      </div>
    </li>
    <li v-for="itemGroup in menuData" v-if="checkRoles(itemGroup.roles)">
      <a v-if="!hasSubitems(itemGroup)" :href="itemGroup.link">
        <i class="material-icons">{{itemGroup.icon}}</i>{{itemGroup.label}}
      </a>
      <template v-else>
        <div class="collapsible-header">
          <i class="material-icons">{{itemGroup.icon}}</i>{{itemGroup.label}}
          <i class="material-icons right">keyboard_arrow_down</i>
        </div>

        <ul class="collapsible-body">
          <li v-for="menuLink in itemGroup.items"
              v-if="checkRoles(menuLink.roles) && checkPermissions(menuLink.permissions)">
            <a :href="menuLink.link">
              <i class="material-icons tiny">{{menuLink.icon}}</i>
              {{menuLink.label}}
            </a>
          </li>
        </ul>
      </template>
    </li>
  </ul>
</template>

<script>
  import menuData from '../../plugins/menu-data'

  export default {
    name: 'SideMenu',
    props: ['user', 'image'],
    data () {
      return {
        menuData: [],
      }
    },
    mounted () {
      this.menuData = menuData
    },
    methods: {
      checkRoles (roles) {
        if (!roles || roles == '') {
          return true
        }
        return this.$hasRole(roles)
      },
      checkPermissions (permissions) {
        if (!permissions || permissions == '') {
          return true
        }
        return this.$hasPermission(permissions)
      },
      hasSubitems (itemGroup) {
        return itemGroup.hasOwnProperty('items')
      },
    },
    computed: {
      roleNames () {
        if (this.roles) {
          return this.roles.join(' ')
        }
      },
    },
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/common/SideMenu.vue